/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebSlownikiKodGet$Xml$Params {
  kod: string;
}

export function apiWebSlownikiKodGet$Xml(http: HttpClient, rootUrl: string, params: ApiWebSlownikiKodGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, apiWebSlownikiKodGet$Xml.PATH, 'get');
  if (params) {
    rb.path('kod', params.kod, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

apiWebSlownikiKodGet$Xml.PATH = '/api/web/slowniki/{kod}';
